import React from 'react';
import { DateSeparatorProps } from 'stream-chat-react';
import './CustomDateSeparator.scss';

/**
 * CustomDateSeparator Component
 * 
 * WhatsApp-style date separator that displays the date in a cute centered bubble.
 * Shows dates in a user-friendly format (e.g., "Today", "Yesterday", or "Day, Date")
 */
export const CustomDateSeparator: React.FC<DateSeparatorProps> = ({ date, formatDate }) => {
  const getFormattedDate = () => {
    if (!date) return '';

    const messageDate = new Date(date);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // Reset time part for comparison
    const resetTime = (d: Date) => {
      d.setHours(0, 0, 0, 0);
      return d;
    };

    const messageDateOnly = resetTime(new Date(messageDate));
    const todayOnly = resetTime(new Date(today));
    const yesterdayOnly = resetTime(new Date(yesterday));

    if (messageDateOnly.getTime() === todayOnly.getTime()) {
      return 'TODAY';
    } else if (messageDateOnly.getTime() === yesterdayOnly.getTime()) {
      return 'YESTERDAY';
    } else {
      // Format: "FRIDAY, MARCH 10, 2025"
      const options: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
      return messageDate.toLocaleDateString('en-US', options).toUpperCase();
    }
  };

  return (
    <div className="custom-date-separator">
      <div className="custom-date-separator__bubble">
        {getFormattedDate()}
      </div>
    </div>
  );
};

